export type OrderDirection = "ASC" | "DESC";
export type NumberOrderBy = "createdAt" | "phoneNumber" | "companyName" | "status";

export interface GetNumbersQueryParams {
  order?: OrderDirection;
  orderBy?: NumberOrderBy;
  search?: string;
  status?: string;
  provider?: string;
}

export interface CompanyNumberItem {
  id: string | number;
  phoneNumber: string;
  friendlyName: string;
  companyId: number;
  companyName?: string;
  status: "active" | "pending" | "unassigned" | "suspended" | string;
  source?: string;
  provider: "twilio" | "telnyx" | "bandwidth" | "amazon_connect" | string;
  createdAt: string;
  updatedAt: string;
}
